import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, METRIC_TYPES, fromLocalInput } from "@/lib/api";
import { Modal } from "@/components/ui-bits";

const UNITS = { WEIGHT: "kg", BODY_FAT: "%", SQUAT_5RM: "kg", BENCH_5RM: "kg", DEADLIFT_5RM: "kg", RUN_5K: "min", CUSTOM: "" };

export const MetricForm = ({ clientId, onClose, onSaved }) => {
  const [f, setF] = useState({ type: "SQUAT_5RM", value: "", unit: "kg", recordedAt: new Date().toISOString().slice(0, 10), note: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value, ...(k === "type" ? { unit: UNITS[e.target.value] } : {}) });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/metrics", { clientId, type: f.type, value: Number(f.value), unit: f.unit || null, recordedAt: fromLocalInput(`${f.recordedAt}T00:00`), note: f.note || null });
      toast.success("Metric logged");
      onSaved();
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <Modal title="LOG PROGRESS" sub="Body stats and lifts show up on the progress chart." onClose={onClose} testId="metric-form-modal">
      <form onSubmit={save}>
        <div className="frow">
          <div><label>Metric</label><select value={f.type} onChange={set("type")} data-testid="metric-type-select">{METRIC_TYPES.map((t) => <option key={t}>{t}</option>)}</select></div>
          <div><label>Date</label><input type="date" value={f.recordedAt} onChange={set("recordedAt")} data-testid="metric-date-input" /></div>
        </div>
        <div className="frow">
          <div><label>Value</label><input type="number" step="0.1" required value={f.value} onChange={set("value")} data-testid="metric-value-input" /></div>
          <div><label>Unit</label><input value={f.unit} onChange={set("unit")} data-testid="metric-unit-input" /></div>
        </div>
        <label>Note</label><input value={f.note} onChange={set("note")} data-testid="metric-note-input" />
        <div className="mfoot">
          <button type="button" className="btn g" onClick={onClose} data-testid="metric-form-cancel">Cancel</button>
          <button className="btn" disabled={busy} data-testid="metric-form-save">Log it</button>
        </div>
      </form>
    </Modal>
  );
};
